// extracted by mini-css-extract-plugin
export default {"main":"UploadingWaitScreen_main__joGpE"};